import { useTranslation } from 'react-i18next';

export default function FinalCTASection() {
  const { t } = useTranslation();

  return (
    <section className="relative py-16 md:py-24 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Minimalist%20geometric%20pattern%20of%20pastel%20color%20blocks%20with%20abstract%20fashion%20silhouettes%2C%20soft%20gradient%20background%20in%20warm%20coral%20and%20sage%20tones%2C%20modern%20clean%20design%20banner&width=1600&height=600&seq=cta-bg-02&orientation=landscape&nocache=true"
          alt="Products grid background"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-primary-900/80 to-primary-700/70" />
      </div>

      <div className="relative z-10 w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-2xl md:text-4xl font-heading font-semibold text-white mb-4">
            {t('final_cta')}
          </h2>
          <p className="text-base md:text-lg text-white/85 mb-10 leading-relaxed">
            {t('final_cta_desc')}
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-8 py-4 bg-white text-primary-700 font-medium rounded-lg hover:bg-white/90 transition-colors text-base whitespace-nowrap"
            >
              <i className="ri-external-link-line" />
              {t('continue_to_main')}
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-8 py-4 bg-white/10 backdrop-blur-sm text-white font-medium rounded-lg hover:bg-white/20 transition-colors text-base whitespace-nowrap border border-white/30"
            >
              <i className="ri-shopping-cart-line" />
              {t('buy_now')}
            </a>
          </div>

          <p className="text-xs text-white/60 mt-6">
            {t('disclaimer_text')}
          </p>
        </div>
      </div>
    </section>
  );
}